import Typography from '../../libs/atoms/Typography';
import { useMediaQuery, useTheme } from '@mui/material';
import useTranslation from '../../states/translation/useTranslation';
import { isDesktopScreen } from '../../libs/utils/screenSizes/screenSizes';
import UpgradeButton from '../../libs/molecules/UpgradeButton';

export const makeDataTestId = (dataTestId = 'eligibility-widget') => {
  return {
    buttonAction: `${dataTestId}.card.button.reset`,
    linkAction: `${dataTestId}.card.button.reset`,
  };
};

interface ResetActionProps {
  onClick: () => void;
  link?: boolean;
}

const ResetAction: React.FC<ResetActionProps> = ({ onClick, link = false }) => {
  const { t } = useTranslation().actions;
  const label = t('eligibility-widget.card.button.reset');
  const theme = useTheme();
  const isDesktop = useMediaQuery(isDesktopScreen(theme));

  const dataTestId = makeDataTestId();

  const handleClick = async () => onClick();

  return link ? (
    <Typography
      variant="body1-link"
      color="link"
      role="button"
      onClick={handleClick}
      data-testid={dataTestId.linkAction}
    >
      {label}
    </Typography>
  ) : (
    <UpgradeButton label={label} onClick={handleClick} fullWidth={!isDesktop} dataTestId={dataTestId.buttonAction} />
  );
};

export default ResetAction;
